// Página /cart: la misma vista que el carrito lateral, para quien llega por URL (§6.9).
// El servidor la pinta con el carrito y funciona sin JavaScript (formulario a /cart con updates[], note y checkout).
// Con JavaScript los cambios se hacen sin recargar; al cargar se vuelve a pedir el carrito por si cambió mientras tanto
// (por ejemplo, una nota que se guardaba al salir de la página anterior).
import { mountCartView, syncHeaderCount } from './cart-view.js';

const root = document.querySelector('[data-cart-page]');
if (root) {
  const config = JSON.parse(root.querySelector('[data-cart-config]').textContent);
  // En /cart no hay carrito lateral: el número de la cabecera lo actualiza esta página.
  document.addEventListener('cart:updated', (event) => syncHeaderCount(config.header, event.detail?.cart));
  mountCartView(root, config, { refresh: true });
}
